// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"28":"bc23dea8","656":"beed3a6a","736":"100a1101"}[chunkId] + ".js";
};